import React from "react";

import type { ApplicationDomain } from "~/models/dto";

import { ApplicationDomainContext } from "./_context";

export const ApplicationDomainBoundary = ({
	applicationDomain,
	children,
	wrapChildren = true,
}: {
	applicationDomain: ApplicationDomain;
	children: React.ReactNode;
	wrapChildren?: boolean;
}) => (
	<ApplicationDomainContext.Provider value={applicationDomain}>
		{wrapChildren ? (
			<div className="contents" data-mode={applicationDomain}>
				{children}
			</div>
		) : (
			children
		)}
	</ApplicationDomainContext.Provider>
);
